// src/components/TabsNavigation.js
import React, { useContext, useCallback } from 'react';
import HomePage    from '../pages/HomePage';
import LikesPage   from '../pages/LikesPage';
import ProPetsPage from '../pages/ProPetsPage';
import ProProfilePage from '../pages/ProProfilePage';
import { AuthContext } from '../context/AuthContext';
import { TabContext }  from '../context/TabContext';
import { ScrollContext } from '../context/ScrollContext';

const TabsNavigation = () => {
  const { user, isAuthenticated } = useContext(AuthContext);
  const isPro = isAuthenticated && user?.is_professional;

  const { activeTab } = useContext(TabContext);
  const { homeScrollPosition, setHomeScrollPosition } = useContext(ScrollContext);

  const handleScroll = useCallback(e => {
    const pos = e.target.scrollTop;
    if (Math.abs(pos - homeScrollPosition) > 30) {
      setHomeScrollPosition(pos);
    }
  }, [homeScrollPosition, setHomeScrollPosition]);

  if (!isPro) {
    // Usuario normal: Home + Likes — AHORA AMBOS MONTADOS SIEMPRE
    return (
      <>
        {/* ─────────────── HOME ─────────────── */}
        <div
          className="home-container"
          style={
            activeTab === 'home'
              // visible y scrollable
              ? { position:'relative', overflowY:'auto', height:'100vh' }
              // oculto pero montado
              : { position:'fixed', top:0, left:0, right:0, bottom:0, overflow:'hidden', visibility:'hidden' }
          }
          onScroll={handleScroll}
        >
          <HomePage />
        </div>

        {/* ─────────────── LIKES ────────────── */}
        <div
          className="likes-container"
          style={
            activeTab === 'likes'
              // visible
              ? { position:'fixed', top:'60px', left:0, right:0, bottom:'60px', overflowY:'auto', backgroundColor:'#fff', visibility:'visible' }
              // oculto pero montado
              : { position:'fixed', top:'60px', left:0, right:0, bottom:'60px', overflow:'hidden', visibility:'hidden' }
          }
        >
          <LikesPage />
        </div>
      </>
    );
  } else {
    // Caso profesional: análogo para ProPetsPage y ProProfilePage…
    return (
      <>
        <div
          className="pro-container"
          style={
            activeTab === 'prof_pets'
              ? { position: 'relative', overflowY: 'auto', height: 'calc(100vh - 120px)', top:'60px' }
              : { position:'fixed', top:0, left:0, right:0, bottom:0, overflow:'hidden', visibility:'hidden' }
          }
        >
          <ProPetsPage />
        </div>
        <div
          className="pro-profile-container"
          style={{
            position:'fixed', top:'60px', left:0, right:0, bottom:'60px',
            overflow:'hidden',
            visibility: activeTab==='prof_profile' ? 'visible' : 'hidden'
          }}
        >
          <ProProfilePage />
        </div>
      </>
    );
  }
};

export default TabsNavigation;
